import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { enhancerRightStyle } from './styles';
function EnhancerRight({ children, size }) {
    return _jsx("div", Object.assign({ css: enhancerRightStyle({ size }) }, { children: children }));
}
export default EnhancerRight;
